exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".checkbox-box{margin-left:-15px;display:inline-block;width:100%}.checkbox-box input[type=checkbox]{-webkit-appearance:none;border:0 none;border-radius:0;width:25px;height:25px;background-color:#fff;margin-right:10px;margin-top:30px;float:left;position:relative}.checkbox-box input[type=checkbox]:checked{background-image:url(" + require("./checkbox.png") + ");background-position:top}.checkbox-box label{padding:25px 0 0;margin:0 0 30px 40px;display:block}.checkbox-box label:first-child{float:left;padding:0;margin:0;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./js-src/markdown-editor/modules/checkbox/checkbox.styl
// module id = 44
// module chunks = 0 1